import { icons } from '../assets/icons';
import { NewsService } from '../services/news';

export class LatestNewsWidgetComponent {
  public render(): string {
    const recentPosts = NewsService.getRecentPosts(3);

    if (recentPosts.length === 0) {
      return '';
    }

    return `
      <section id="news" class="py-16 md:py-24 border-t border-terminal-border bg-terminal-bgDark/50 font-mono text-left">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div class="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
            <div class="space-y-3">
              <div class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-matrix-950/80 text-matrix-400 border border-matrix-800 shadow-glow-sm">
                ${icons.zap('w-3.5 h-3.5 text-matrix-400')}
                <span>// PROJECT NEWS & UPDATES</span>
              </div>
              <h2 class="text-2xl sm:text-4xl font-extrabold text-white tracking-tight">
                Latest News & Release Notes
              </h2>
              <p class="text-xs sm:text-sm text-terminal-muted max-w-xl">
                Stay updated with recent release announcements, terminal graphics tutorials, and guides.
              </p>
            </div>

            <a 
              href="#/news" 
              class="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl font-bold text-xs text-matrix-400 hover:text-matrix-300 bg-terminal-card hover:bg-terminal-cardLight border border-terminal-border hover:border-matrix-500 transition-all shadow-glow-sm self-start md:self-auto"
            >
              <span>View All News & Blog</span>
              ${icons.arrowRight('w-3.5 h-3.5')}
            </a>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            ${recentPosts.map(post => `
              <article class="p-5 rounded-2xl bg-terminal-card border border-terminal-border hover:border-matrix-500/60 shadow-glow-sm hover:shadow-glow flex flex-col justify-between group transition-all">
                <div class="space-y-3">
                  
                  ${post.coverImage ? `
                    <div class="rounded-xl overflow-hidden border border-matrix-900 bg-black aspect-video">
                      <img 
                        src="${post.coverImage}" 
                        alt="${post.title}" 
                        class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" 
                        loading="lazy"
                      />
                    </div>
                  ` : ''}

                  <div class="flex items-center justify-between text-xs">
                    <span class="px-2 py-0.5 rounded text-[10px] font-semibold bg-matrix-950 text-matrix-400 border border-matrix-800">
                      #${post.tags[0] || 'News'}
                    </span>
                    <span class="text-[11px] text-terminal-muted">${post.readingTime}</span>
                  </div>

                  <h3 class="font-bold text-white group-hover:text-matrix-400 transition-colors text-base line-clamp-2">
                    <a href="#/news/${post.slug}">${post.title}</a>
                  </h3>

                  <p class="text-xs text-terminal-fg/80 leading-relaxed line-clamp-3">
                    ${post.summary}
                  </p>
                </div>

                <div class="pt-4 mt-4 border-t border-terminal-border/60 flex items-center justify-between text-xs">
                  <span class="text-[11px] text-terminal-muted">${post.date}</span>
                  <a href="#/news/${post.slug}" class="font-bold text-matrix-400 group-hover:text-matrix-300 flex items-center gap-1">
                    <span>Read →</span>
                  </a>
                </div>
              </article>
            `).join('')}
          </div>

        </div>
      </section>
    `;
  }
}
